import React, { useEffect } from 'react';

type Props = {
    onKeyDown?(e: KeyboardEvent): void;
}

export const WindowEventListener: React.FC<Props> = (props) => {
    useEffect(() => {
        if (props.onKeyDown) {
            window.addEventListener('keydown', props.onKeyDown);
        }

        return () => {
            if (props.onKeyDown) {
                window.removeEventListener('keydown', props.onKeyDown);
            }
        }

    }, []);

    return (
        <>
            {props.children}
        </>
    );
};
